// extracted by mini-css-extract-plugin
export default {"container":"_1StRp","search":"_3lYBW","large":"YeTCa","side-by-side-mobile":"_3dule","sideBySideMobile":"_3dule","userName":"_60KfD","profileLink":"m2OY2"};